import {
  Health,
  HealthStatusEnum,
  ListHealthResponse,
} from '@cast/types-services';

export const generateServicesHealth = (
  mockHealth: Partial<Health> = {}
): ListHealthResponse => {
  return {
    items: [
      {
        serviceId: 'service-1',
        status: HealthStatusEnum.HEALTHY,
        uptimePercentage: 99.98,
        ...mockHealth,
      },
    ],
  };
};
